import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';
import { isUndefined } from 'lodash';
import { listingDict } from '../constants/GeneralConstants';

export const selectRepeatableSectionCount = ({ listing }) => listing.repeatableSectionCount;

export const selectUploadedImages = ({ listing }) => listing.uploadedPhotos;

export const selectCurrentImages = ({ listing }) => listing.currentImages;

export const selectUploadedSupplements = ({ listing }) => listing.uploadedSupplements;

export const selectCurrentListing = ({ listing }) => listing?.listingClicked;

export const selectListingStdStatus = ({ listing }) => listing?.listingClicked?.StandardStatus;

export const selectListingStdStatusVerb = ({ listing }) => listing?.listingClicked?.StandardStatusVerb;

export const selectCurrentListingPreferredPhotoDetails = ({ listing }) => listing.listingPreferredPhotoDetails;

export const selectCurrentListingPhoto = ({ listing }) => listing.listingPhoto;

export const selectListingSelected = ({ listing }) => listing.selectedListing;

export const selectMyListings = ({ listing }) => listing.myListings;

export const selectListingSelectedPhotos = createSelector(selectListingSelected, selectedListing => selectedListing?.photos ?? []);

export const selectListingSelectedRooms = createSelector(selectListingSelected, selectedListing => selectedListing?.rooms ?? []);

export const selectListingSelectedSupplements = createSelector(selectListingSelected, selectedListing => selectedListing?.supplements ?? []);

export const selectListingSelectedOpenHouses = createSelector(selectListingSelected, selectedListing => selectedListing?.openHouses ?? []);

export const selectListingSelectedParcels = createSelector(selectListingSelected, selectedListing => selectedListing?.parcels ?? []);

export const selectListingSelectedDoors = createSelector(selectListingSelected, selectedListing => selectedListing?.doors ?? []);

export const selectListingSelectedUnits = createSelector(selectListingSelected, selectedListing => selectedListing?.units ?? []);

export const selectListingSelectedHistory = createSelector(selectListingSelected, selectedListing => selectedListing?.history ?? []);

export const getSelectedListingData = ({ listing }) => listing?.selectedListing?.listing;

export const selectListingPhotoSortOrder = ({ listing }) => listing.listingPhotoSortOrder;

export const selectListingCodeFromListing = createSelector(
  selectListingSelected,
  listing => listing?.PropertyType.toString().toLowerCase(),
);

export const selectListingTypeForViewing = createSelector(
  selectListingCodeFromListing,
  listingType => listingDict[listingType],
);

export const selectListingSelectedByFilled = ({ listing }) => {
  const selectedListing = [];
  const dict = {};
  if (!isEmpty(listing.selectedListing)) {
    let slctListingData;
    if (listing.selectedListing.listing) {
      slctListingData = listing.selectedListing.listing; // Loading a listing
    } else {
      [slctListingData] = listing.selectedListing; // TAP data
    }
    Object.entries(slctListingData).map(([key, value]) => {
      if (value !== null) {
        dict[key] = value;
      }
      return null;
    });
  }

  if (!isEmpty(dict)) {
    selectedListing.push(dict);
  }
  return selectedListing;
};

// unused?
export const selectAutoPopSelectedByFieldName = ({ listing }, fieldName) => {
  const dict = {};
  if (listing.autoPopSelected) {
    const [slctListingData] = listing.autoPopSelected[0];
    Object.entries(slctListingData).map(([key, value]) => {
      if (key === fieldName) {
        dict[key] = value;
      }
      return null;
    });
  }
  return dict;
};

/* retrieves ListingId, UnparsedAddress and StandardStatus values from the current listing */
export const selectEditListingHeaderInfo = createSelector(selectListingSelected, listing => {
  const listingInfo = [];
  if (!isEmpty(listing)) {
    Object.entries(listing).map(([key, value]) => {
      if (key === 'listing') {
        const unitNumber = isUndefined(value?.UnitNumber) ? '' : `${value?.UnitNumber}, `;
        const streetNumber = isUndefined(value?.StreetNumber) ? '' : `${value?.StreetNumber} `;
        const streetName = isUndefined(value?.StreetName) ? '' : `${value?.StreetName} `;
        const streetSuffix = isUndefined(value?.StreetSuffix) ? '' : `${value?.StreetSuffix} `;
        const streetDirSuffix = isUndefined(value?.StreetDirSuffix) ? '' : `${value?.StreetDirSuffix}`;
        const unparsedAddress = value?.UnparsedAddress
          ? value?.UnparsedAddress
          : `${unitNumber}${streetNumber}${streetName}${streetSuffix}${streetDirSuffix}`;

        listingInfo.push({
          ListingId: value?.ListingId,
          PropertyType: value?.PropertyType,
          StandardStatus: value?.StandardStatus,
          UnparsedAddress: unparsedAddress,
        });
      }
      return null;
    });
  }
  return listingInfo;
});

export const selectSectionsPerRepeatableSection = createSelector(selectRepeatableSectionCount, countListing => {
  const countPerSection = {};
  if (countListing) {
    const {
      Photos = [],
      Rooms = [],
      Supplements = [],
      OpenHouses = [],
      Doors = [],
      Parcels = [],
      Units = [],
      History = [],
    } = countListing;
    countPerSection.Photos = Photos.filter(photo => !photo);
    countPerSection.Rooms = Rooms.filter(room => !room);
    countPerSection.Supplements = Supplements.filter(supp => !supp);
    countPerSection.OpenHouses = OpenHouses.filter(openHouse => !openHouse);
    countPerSection.Doors = Doors.filter(door => !door);
    countPerSection.Parcels = Parcels.filter(parcel => !parcel);
    countPerSection.Units = Units.filter(unit => !unit);
    countPerSection.History = History.filter(hist => !hist);
  }
  return countPerSection;
});
